import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Chip, NumberDisplay, TextBody, Tooltip } from "@opensea/ui-kit";
import { StacksFilled } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
export const CollectionItemCountChipFragment = graphql(`
  fragment CollectionItemCountChip on Collection {
    stats {
      totalSupply
      uniqueItemCount
    }
    standard
  }
`);
export function CollectionItemCountChip(t0) {
  const $ = _c(38);
  const {
    collection: collectionKey,
    variant: t1,
    chipVariant
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  let t2;
  if ($[0] !== collectionKey) {
    t2 = readFragment(CollectionItemCountChipFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const collection = t2;
  const totalSupply = collection.stats.totalSupply || 0;
  const t = useTranslations("CollectionItemCountChip");
  if (totalSupply === 0) {
    return null;
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <StacksFilled size={12} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== totalSupply) {
    t4 = <NumberDisplay data-testid="total-supply" display="full" value={totalSupply} />;
    $[3] = totalSupply;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== chipVariant || $[6] !== t4) {
    t5 = <Chip className="gap-1" variant={chipVariant}>{t3}{t4}</Chip>;
    $[5] = chipVariant;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const itemsChip = t5;
  if (collection.standard === "ERC721" || collection.standard === "CRYPTOPUNKS") {
    let t6;
    if ($[8] !== t || $[9] !== totalSupply) {
      t6 = totalSupply === 1 ? t("item") : t("items");
      $[8] = t;
      $[9] = totalSupply;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== t6 || $[12] !== totalSupply) {
      t7 = <TextBody><NumberDisplay display="full" suffix={t6} value={totalSupply} /></TextBody>;
      $[11] = t6;
      $[12] = totalSupply;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== itemsChip || $[15] !== t7) {
      t8 = <Tooltip content={t7}>{itemsChip}</Tooltip>;
      $[14] = itemsChip;
      $[15] = t7;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    return t8;
  }
  let t6;
  if ($[17] !== t || $[18] !== totalSupply) {
    t6 = totalSupply === 1 ? t("uniqueItem") : t("uniqueItems");
    $[17] = t;
    $[18] = totalSupply;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const uniqueItemSuffix = t6;
  let t7;
  if ($[20] !== t || $[21] !== totalSupply) {
    t7 = totalSupply === 1 ? t("totalItem") : t("totalItems");
    $[20] = t;
    $[21] = totalSupply;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const totalItemSuffix = t7;
  const t8 = variant === "compact" ? "unique" : uniqueItemSuffix;
  const t9 = collection.stats.uniqueItemCount || 0;
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <NumberDisplay display="full" suffix={t8} value={t9} />;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== chipVariant || $[27] !== t10) {
    t11 = <Chip variant={chipVariant}>{t10}</Chip>;
    $[26] = chipVariant;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== totalItemSuffix || $[30] !== totalSupply) {
    t12 = <TextBody><NumberDisplay display="full" suffix={totalItemSuffix} value={totalSupply} /></TextBody>;
    $[29] = totalItemSuffix;
    $[30] = totalSupply;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== itemsChip || $[33] !== t12) {
    t13 = <Tooltip content={t12}>{itemsChip}</Tooltip>;
    $[32] = itemsChip;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t11 || $[36] !== t13) {
    t14 = <>{t11}{t13}</>;
    $[35] = t11;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}